import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

const getNestedValue = (obj, path) =>
  path.split(".").reduce((acc, key) => (acc ? acc[key] : ""), obj);

export function useDashboardTable(rows) {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [expandedRowId, setExpandedRowId] = useState(null);
  const location = useLocation();
  const refe = useRef();

  const handleSort = (columnId) => {
    const isAsc = orderBy === columnId && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(columnId);
  };

  const handleExpandClick = (rowId) => {
    setExpandedRowId((prev) => (prev === rowId ? null : rowId));
  };

  const sortedRows = structuredClone(rows).sort((a, b) => {
    const aVal = getNestedValue(a, orderBy);
    const bVal = getNestedValue(b, orderBy);

    if (aVal == null) return 1;
    if (bVal == null) return -1;

    const DATE_FORMATS = [
      "YYYY-MM-DD",
      "YYYY/MM/DD",
      "DD-MM-YYYY",
      "DD/MM/YYYY",
      "YYYY-MM-DD HH:mm:ss",
      "YYYY-MM-DDTHH:mm:ss",
      "YYYY-MM-DDTHH:mm:ss.SSSZ",
    ];

    const isDateLike = (val) => {
      if (typeof val !== "string") return false;
      if (/[a-zA-Z]/.test(val)) return false;
      return dayjs(val, DATE_FORMATS, true).isValid();
    };

    const aIsDate = isDateLike(aVal);
    const bIsDate = isDateLike(bVal);

    if (aIsDate && bIsDate) {
      return order === "asc"
        ? dayjs(aVal).valueOf() - dayjs(bVal).valueOf()
        : dayjs(bVal).valueOf() - dayjs(aVal).valueOf();
    }

    const aNum = Number(aVal);
    const bNum = Number(bVal);
    if (!isNaN(aNum) && !isNaN(bNum)) {
      return order === "asc" ? aNum - bNum : bNum - aNum;
    }

    return order === "asc"
      ? String(aVal).localeCompare(String(bVal), undefined, {
          numeric: true,
          sensitivity: "base",
        })
      : String(bVal).localeCompare(String(aVal), undefined, {
          numeric: true,
          sensitivity: "base",
        });
  });

  useEffect(() => {
    if (location.state?.id) {
      setExpandedRowId(location.state?.id);
      setTimeout(() => {
        refe.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 500);
    }
  }, [location.state]);

  return {
    expandedRowId,
    sortedRows,
    handleExpandClick,
    handleSort,
    order,
    orderBy,
    location,
    getNestedValue,
    refe,
  };
}
